<script setup>
</script>
<template>
  <fieldset v-bind="$attrs">
    <legend v-if="$slots.legend">
      <slot name="legend" />
    </legend>
    <slot />
  </fieldset>
</template>
<style scoped>
fieldset {
    background: #fff;
    color: var(--text-primary);
    padding: 0.75em 0 0;
    border: none;
    border-top: 1px solid var(--text-secondary);

    legend {
        cursor: default;
        background-color: #fff;
        color: var(--text-primary);
        z-index: 1;
        position: relative;
        user-select: none;
        font-weight: 500;
        padding: 0 0.5rem 0 0;
    }

    &.no-border {
      border-top: none;
    }
    
    &.bordered {
        border: 3px solid var(--text-primary);
        background-color: rgba(0, 0, 0, 0.01);
        border-radius: 0.5rem;
        overflow: hidden;
        padding: 1rem;
        
        legend {
            text-transform: uppercase;
            letter-spacing: -0.25px;
            background-color: none;
            padding: 0 0.5rem;
            background: none;
        }
    }
}
</style>